import { createAction } from '@sde/widgets-core/src/redux/helpers/createAction';

import {
  SET_SHOW_PAGE_COLLAPSING_HEADER,
  SET_IS_SUB_MENU_DROPDOWN_CONTENT,
} from './constants';

export const setShowPageCollapsingHeader = (data) => {
  return createAction({
    type: SET_SHOW_PAGE_COLLAPSING_HEADER,
    payload: data,
  });
};

export const setIsSubMenuDropDownContent = (data) => {
  return createAction({
    type: SET_IS_SUB_MENU_DROPDOWN_CONTENT,
    payload: data,
  });
};
